<div class="main-page cadastros">
    <div class="container-fluid">
        <app-title>{{ title ? title : 'Inserir novo' }} </app-title>

        <div class="row mt-3 no-gutters p-4 row-form">
            <div class="col-12">
                <form [formGroup]="atividadeForm" (ngSubmit)="submitForm()">
                    <h2 class="mb-3">Nova Atividade</h2>
                    <div class="form-row">
                        <div class="form-group col-lg-2">
                            <mat-form-field appearance="outline">
                                <mat-label>Código</mat-label>
                                <input formControlName="cdCodigo" matInput placeholder="Código" maxlength="2" minlength="2" (keypress)="numberOnly($event)" required />
                            </mat-form-field>

                            <validation-errors [form]="atividadeForm" controlLabel="Código" controlName="cdCodigo">
                            </validation-errors>
                        </div>
                        <div class="form-group col-lg-10">
                            <mat-form-field appearance="outline">
                                <mat-label>Nome</mat-label>
                                <input formControlName="nmNome" matInput placeholder="Nome" maxlength="120" required/>
                            </mat-form-field>

                            <validation-errors [form]="atividadeForm" controlLabel="Nome" controlName="nmNome">
                            </validation-errors>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-12">
                            <mat-form-field appearance="outline">
                                <mat-label>Mensagem</mat-label>
                                <input formControlName="dsObservacao" matInput maxlength="500"
                                    placeholder="Observação" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div *ngIf="errorMessage" class="alert alert-danger">
                        {{ errorMessage }}
                    </div>

                    <div class="form-group mt-2 mb-0 text-center">
                        <back-button></back-button>
                        <button type="submit"
                            class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
                            Salvar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
